module.exports = __webpack_public_path__ + "img/content-generator-ia.a033532d.png";